"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMediaLinkDef = exports.MediaLinkDef = void 0;
const tslib_1 = require("tslib");
const t = tslib_1.__importStar(require("io-ts"));
exports.MediaLinkDef = t.intersection([
    t.strict({
        select: t.literal("media"),
    }),
    t.partial({
        allowText: t.boolean,
    }),
]);
function defaultMediaLinkDef(config) {
    return {
        select: "media",
        allowText: true,
        ...config,
    };
}
exports.defaultMediaLinkDef = defaultMediaLinkDef;
